<template>
  <tbody>
    <tr>
      <td>
        <span v-if="personLocation.lastUpdateDate">
          {{ personLocation.lastUpdateDate | formatDateMMDDYYYY }}
        </span>
      </td>
      <td v-if="this.fieldEnabled('SCHOOL_YEAR')">
        {{ personLocation.schoolYear }}
      </td>
      <td>
        <div>
          <div>
            <router-link
              v-if="personLocation.districtName && personLocation.districtName !== null"
              :to="{
                name: 'PIDistrictInfoDetails',
                params: { code: personLocation.districtCode },
              }"
                class="location-name"
                style="font-weight: 700"
            >
              {{ personLocation.districtName }}
            </router-link>
            <span v-else>
              --
            </span>
            <span class="color-grey" style="padding-left: 0.25rem">
              ({{ personLocation.districtCode }})
            </span>
          </div>
          <div style="font-style: italic">
            <router-link
              v-if="personLocation.schoolName && personLocation.schoolName !== null"
              :to="{
                name: 'PISchoolInfoDetails',
                params: {
                    districtCode: personLocation.districtCode,
                    schoolCode: personLocation.schoolCode
                },
              }"
              class="location-name"
            >
              {{ personLocation.schoolName }}
            </router-link>
            <span v-else>
              --
            </span>
            <span class="color-grey" style="padding-left: 0.25rem">
              ({{ personLocation.schoolCode }})
            </span>
          </div>
        </div>
      </td>
      <td v-if="this.fieldEnabled('LOCAL_STUDENT_ID')">
        <div class="has-text-weight-bold">
          {{ personLocation.localId !== null ? personLocation.localId : null }}
        </div>
        <div class="color-grey" v-if="this.fieldEnabled('SOURCE_CODE')">
          {{ mapSource(personLocation.sourceCode) }}
        </div>
      </td>
      <td v-if="this.fieldEnabled('ALT_STUDENT_ID')">
        <div class="has-text-weight-bold">
          {{ personLocation.altPersonId }}
        </div>
        <div class="color-grey" v-if="this.fieldEnabled('ALT_SOURCE_SIS_CODE')">
          {{ mapSource(personLocation.altSourceCode) }}
        </div>
      </td>
      <td v-if="this.currentPersonTypeCategory === 'STUDENT'
        && this.fieldEnabled('GRADE_CODE')">
        <div>
          {{ mapGrades(personLocation.gradeCode) }}
        </div>
      </td>
      <td v-if="this.currentPersonTypeCategory === 'EMPLOYEE'
        && this.fieldEnabled('HIRE_DATE')">
        <div>
          {{ personLocation.hireDate | formatDateMMDDYYYY }}
        </div>
      </td>
      <td v-if="this.currentPersonTypeCategory === 'EMPLOYEE'
        && this.fieldEnabled('JOB_CLASS_CODE')">
        <div>
          {{ mapTitle(personLocation.jobClassCode) }}
        </div>
      </td>
      <td v-if="this.currentPersonTypeCategory === 'EMPLOYEE'
        && this.fieldEnabled('SALARY')">
        <div>
          {{ personLocation.salary | formatSalary }}
        </div>
      </td>
      <td v-if="this.fieldEnabled('ACTIVE')">
        <span class="has-text-weight-bold">
          {{ activeStatus }}
        </span>
      </td>
      <td style="text-align: right">
        <router-link
          v-if="this.activeModule.name === 'personId'"
          tabindex="0"
          title="View details"
          :to="{
            name: 'PidMasterLocationInfoDetails',
            query: {
              districtCode: personLocation.districtCode,
              schoolCode: personLocation.schoolCode,
              personType: personLocation.personType,
              retired: isRetired,
            },
          }"
        >
          <font-awesome-icon
            :icon="['far', 'angle-double-right']"
            size="2x"
            title="View Details"
          />
        </router-link>
        <router-link
          v-if="this.activeModule.name === 'directMatch'"
          tabindex="0"
          title="View details"
          :to="{
            name: 'DmMasterLocationInfoDetails',
            query: {
              districtCode: personLocation.districtCode,
              schoolCode: personLocation.schoolCode,
              personType: personLocation.personType,
              retired: isRetired,
            },
          }"
        >
          <font-awesome-icon
            :icon="['far', 'angle-double-right']"
            size="2x"
            title="View Details"
          />
        </router-link>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import FieldLabels from '@/mixins/FieldLabels';

library.add(
  faAngleDoubleRight,
);
export default {
  mixins: [
    FieldLabels,
  ],
  props: {
    currentPersonTypeCategory: {
      type: String,
      default: null,
    },
    isRetired: {
      type: Boolean,
      default: false,
    },
    personLocation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
    }),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('lookups', [
      'activeGrades',
      'sources',
      'activeTitles',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldEnabledForPersonType',
    ]),
    activeStatus() {
      if (this.personLocation.active === true) {
        return 'Active';
      }
      if (this.personLocation.active === false) {
        return 'Inactive';
      }
      return null;
    },
  },
  methods: {
    fieldEnabled(code) {
      return this.getFieldEnabledForPersonType(code, 'ASSIGN', this.personLocation.personType);
    },
    mapGrades(gradeCode) {
      if (gradeCode) {
        return this.activeGrades.find(grade => grade.code === gradeCode).description;
      }
      return '\u00A0';
    },
    mapSource(code) {
      if (code) {
        return this.sources.find(s => s.code === code).description;
      }
      return '\u00A0';
    },
    mapTitle(code) {
      if (code) {
        return this.activeTitles.find(t => t.code === code).description;
      }
      return '\u00A0';
    },
  },
  filters: {
    formatSalary(value) {
      if (value) {
        if (value > 0) {
          return `$${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
        }
        return '*';
      }
      return '\u00A0';
    },
  },
};
</script>

<style lang="sass" scoped>
.location-name
    font-size: 12px
.color-grey
    color: #767676
</style>
